export type GamematKind = 'cartoon' | 'flat' | 'league'

export type GamematDef = {
  id: string
  kind: GamematKind
  src: string
}

export const DEFAULT_MAT_ID = 'puzzle-dusk'

export const GAMEMATS: GamematDef[] = [
  { id: 'puzzle-dusk', kind: 'cartoon', src: '/assets/mats/puzzle-dusk.webp' },
  { id: 'white-sky', kind: 'cartoon', src: '/assets/mats/white-sky.webp' },
  { id: 'moon-circle', kind: 'cartoon', src: '/assets/mats/moon-circle.webp' },
  { id: 'ember-wings', kind: 'cartoon', src: '/assets/mats/ember-wings.webp' },
  { id: 'sogen-hills', kind: 'cartoon', src: '/assets/mats/sogen-hills.webp' },
  { id: 'umi-tide', kind: 'cartoon', src: '/assets/mats/umi-tide.webp' },
  { id: 'sand-temple', kind: 'cartoon', src: '/assets/mats/sand-temple.webp' },
  { id: 'toon-fair', kind: 'cartoon', src: '/assets/mats/toon-fair.webp' },
  { id: 'shadow-chains', kind: 'cartoon', src: '/assets/mats/shadow-chains.webp' },
  { id: 'kingdom-arena', kind: 'cartoon', src: '/assets/mats/kingdom-arena.webp' },
  { id: 'mystic-circle', kind: 'cartoon', src: '/assets/mats/mystic-circle.webp' },
  { id: 'forbidden-seal', kind: 'cartoon', src: '/assets/mats/forbidden-seal.webp' },
  { id: 'knight-charge', kind: 'cartoon', src: '/assets/mats/knight-charge.webp' },
  { id: 'elf-grove', kind: 'cartoon', src: '/assets/mats/elf-grove.webp' },
  { id: 'light-swords', kind: 'cartoon', src: '/assets/mats/light-swords.webp' },
  { id: 'last-call', kind: 'cartoon', src: '/assets/mats/last-call.png' },
  { id: 'navy-puzzle', kind: 'flat', src: '/assets/mats/navy-puzzle.webp' },
  { id: 'crimson-eye', kind: 'flat', src: '/assets/mats/crimson-eye.webp' },
  { id: 'forest-leaf', kind: 'flat', src: '/assets/mats/forest-leaf.webp' },
  { id: 'gold-star', kind: 'flat', src: '/assets/mats/gold-star.webp' },
  { id: 'violet-moon', kind: 'flat', src: '/assets/mats/violet-moon.webp' },
  { id: 'charcoal-hex', kind: 'flat', src: '/assets/mats/charcoal-hex.webp' },
  { id: 'teal-drop', kind: 'flat', src: '/assets/mats/teal-drop.webp' },
  { id: 'ember-flame', kind: 'flat', src: '/assets/mats/ember-flame.webp' },
  { id: 'ivory-disk', kind: 'flat', src: '/assets/mats/ivory-disk.webp' },
  { id: 'slate-tribute', kind: 'flat', src: '/assets/mats/slate-tribute.webp' },
  { id: 'league-duelist', kind: 'league', src: '/assets/mats/league-duelist.webp' },
  { id: 'league-challenger', kind: 'league', src: '/assets/mats/league-challenger.webp' },
  { id: 'league-champion', kind: 'league', src: '/assets/mats/league-champion.webp' },
  { id: 'league-king', kind: 'league', src: '/assets/mats/league-king.webp' },
]

const BY_ID = new Map(GAMEMATS.map((mat) => [mat.id, mat]))

export function isGamematId(id: string): boolean {
  return BY_ID.has(id)
}

export function gamematById(id: string): GamematDef | undefined {
  return BY_ID.get(id)
}

/**
 * Concrete catalog id for the wire. `random` is not legal here — the client
 * resolves it before join so both seats see the same art.
 */
export function parsePlaymatId(raw: unknown): string {
  if (typeof raw === 'string' && BY_ID.has(raw)) return raw
  return DEFAULT_MAT_ID
}
